import React from 'react';

const Map = () => (
  <div className="Map">
    <div class="maps-area overflow-hidden default-padding-bottom">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <div class="google-maps">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31113.33986716095!2d80.20416850211033!3d12.896949827717968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525b79de7f381b%3A0xffbb2dd48afe3f1b!2sSholinganallur%2C%20Chennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1767619163305!5m2!1sen!2sin"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
);

export default Map;
